var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c("d2-quill", {
        staticStyle: { "min-height": "200px", "margin-bottom": "20px" },
        on: {
          "text-change": _vm.textChangeHandler,
          "selection-change": _vm.selectionChangeHandler,
          "editor-change": _vm.editorChangeHandler
        },
        model: {
          value: _vm.value,
          callback: function($$v) {
            _vm.value = $$v
          },
          expression: "value"
        }
      }),
      _c(
        "el-button",
        { attrs: { type: "primary" }, on: { click: _vm.handleAddRow } },
        [_vm._v(" 添加一行 ")]
      ),
      _c(
        "el-card",
        { staticClass: "d2-card d2-mt", attrs: { shadow: "never" } },
        [_c("d2-highlight", { attrs: { code: _vm.value, "format-html": "" } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }